const routes = [
	{
		path: '/',
		name: 'home',
		component: () => import('@/views/home/index.vue'),
		meta: {
			title: '首页'
		}
	},
	{
		path: '/landPage',
		name: 'landPage',
		component: () => import('@/views/landPage/landPage.vue'),
		meta: {
			title: 'K mart'
		}
	},
	{
		path: '/inviteFriends',
		name: 'inviteFriends',
		component: () => import('@/views/inviteFriends/inviteFriends.vue'),
		meta: {
			title: '邀请好友'
		}
	},
	{
		path: '/activity',
		name: 'activity',
		component: () => import('@/views/activity/activity.vue'),
		meta: {
			title: '活动'
		}
	},
	{
		path: '/document',
		name: 'document',
		component: () => import('@/views/document/document.vue'),
		meta: {
			title: '文档'
		}
	},
	{
		path: '/deleteData',
		name: 'deleteData',
		component: () => import('@/views/deleteData/deleteData.vue'),
		meta: {
			title: '申请删除骑手账号数据'
		}
	},
	{
		path: '/deleteDataNotice',
		name: 'deleteDataNotice',
		component: () => import('@/views/deleteData/notice.vue'),
		meta: {
			title: 'KeyMart Account Deletion Notice'
		}
	},
]

export default routes
